import { render, staticRenderFns } from "./StarsCanvas.vue?vue&type=template&id=7d137008&scoped=true"
import script from "./StarsCanvas.vue?vue&type=script&lang=js"
export * from "./StarsCanvas.vue?vue&type=script&lang=js"
import style0 from "./StarsCanvas.vue?vue&type=style&index=0&id=7d137008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d137008",
  null
  
)

export default component.exports